export default function (gaParams) {
  try {
    var ga = window.ga;
    if (gaParams.length === 2) {
      ga("send", "event", gaParams[0], gaParams[1]);
    } else if (gaParams.length == 3) {
      ga("send", "event", gaParams[0], gaParams[1], gaParams[2]);
    }
  } catch (e) {
    console.error("GA Error!");
  }
}